import type { GraftabilityIssue } from '@/core/utils/graftability'
import {
  formatGraftabilityMemberLocation,
  getGraftabilityIssueKindLabel,
  getGraftabilityIssueSummary,
  GRAFTABILITY_FILTER_HINT,
} from '@/core/utils/graftability/formatGraftabilityIssue'

import styles from './GraftabilityIssueList.module.scss'

interface GraftabilityIssueListProps {
  issues: GraftabilityIssue[]
  limit?: number
  showFilterHint?: boolean
  className?: string
}

export function GraftabilityIssueList({ issues, limit, showFilterHint = true, className }: GraftabilityIssueListProps) {
  if (issues.length === 0) return null

  const visibleIssues = limit ? issues.slice(0, limit) : issues
  const hiddenCount = limit ? Math.max(issues.length - limit, 0) : 0

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      <ul className={styles.list}>
        {visibleIssues.map((issue) => (
          <li
            key={`${issue.classFqn}-${issue.memberName}-${issue.typeLabel}-${issue.kind}-${issue.message}`}
            className={styles.item}
          >
            <div className={styles.itemHeader}>
              <span className={styles.kindBadge}>{getGraftabilityIssueKindLabel(issue.kind)}</span>
            </div>
            <p className={styles.location}>{formatGraftabilityMemberLocation(issue)}</p>
            <p className={styles.type}>
              Type: <code className={styles.typeCode}>{issue.typeLabel}</code>
            </p>
            <p className={styles.summary}>{getGraftabilityIssueSummary(issue)}</p>
          </li>
        ))}
      </ul>

      {hiddenCount > 0 && <p className={styles.moreIssues}>+ {hiddenCount} more issues in this module</p>}

      {showFilterHint && <p className={styles.filterHint}>{GRAFTABILITY_FILTER_HINT}</p>}
    </div>
  )
}
